import { Box, HStack, Text } from 'native-base';

// Props
type Props = {
  onPress?: any;
  text: string;

  // Properties
  disabled?: boolean;
  isLoading?: boolean;

  // Icons
  startIcon?: any;
  endIcon?: any;

  // Styling (quick)
  mini?: boolean;
  bg?: string;
  color?: string;
  fontWeight?: number;
  fontSize?: number;
  lineHeight?: number | string;
  px?: number | string;
  py?: number | string;
  size?: number | string;
  style?: object; // Styling (full)
};

export const TertiaryButton = ({
  onPress = undefined,
  text,

  disabled = false,
  isLoading = false,

  startIcon = undefined,
  endIcon = undefined,

  mini = false,
  bg = 'transparent',
  color = 'red.200',
  fontWeight = 600,
  fontSize = 15,
  lineHeight = fontSize + 4,
  px = undefined,
  py = undefined,
  size = 'md',
  style = undefined,
}: Props) => {
  return (
    <Box
      onClick={!disabled && !isLoading ? onPress : undefined}
      px={mini ? '10px' : px}
      py={mini ? '7px' : py}
      rounded={mini ? '7px' : 'full'}
      // size={size}
      borderColor={'surface.200'}
      borderWidth={mini ? 1 : 0}
      bg={bg}
      opacity={disabled || isLoading ? 0.5 : 1}
      style={{
        cursor: disabled || isLoading ? 'not-allowed' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        ...style,
      }}
      _pressed={{
        backgroundColor: bg,
        opacity: 0.8,
      }}
      _hover={{
        backgroundColor: bg,
        opacity: 1,
      }}
    >
      <HStack alignItems={'center'}>
        {startIcon && <Box mr={2}>{startIcon}</Box>}
        <Text
          fontFamily="body"
          textAlign="center"
          color={color}
          fontSize={fontSize}
          fontWeight={fontWeight}
          lineHeight={lineHeight}
          letterSpacing="-0.3px"
        >
          {text}
        </Text>
        {endIcon && <Box ml={1}>{endIcon}</Box>}
      </HStack>
    </Box>
  );
};
